
import {createSlice} from "@reduxjs/toolkit";

export const licenseSearchSlice = createSlice({
    name: 'licenseSearchSlc',
    initialState: {value: {
            propertyId: null,
            productName: null,
            episodeName: null,
            photoStartDateFrom: null,
            photoStartDateTo: null,
            seriesExternalId: null,
            seriesName: null,
            seasonExternalId: null,
            seasonNumberFrom: null,
            seasonNumberTo: null,
            seasonName: null,
            licensee: null,
            id: null,
            externalId: null,
            amountFrom: null,
            amountTo: null,
            availBeginFrom: null,
            availBeginTo: null,
            availEndFrom: null,
            availEndTo: null,
            executionDateFrom: null,
            executionDateTo: null,
            market: null,
            territory: null,
                    status: null,
            participations: null,
            residuals: null,
            royalties: null
        }},
    reducers:

{
        changeLicenseSearch: (state, action) => {
                state.value = {
                        ...state.value,  // Keep existing fields
                        ...action.payload // Merge new values
                };
        }
}
});

export const { changeLicenseSearch } = licenseSearchSlice.actions;

export default  licenseSearchSlice.reducer ;
